// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3Aj-J","content":"styles_content__29yL7","checkbox":"styles_checkbox__11YYd","checkboxLabel":"styles_checkboxLabel__3P4O7"};